import './style.scss';

import * as XLSX from 'xlsx';
import xls from '../../assets/icons/xls.svg';
import { useEffect, useState } from 'react';

function DownloadBeneficiaries({ beneficiaries, genders }) {
  const [beneficiariesInfo, setBeneficiariesInfo] = useState([]);

  function generateInfo() {
    const now = new Date();
    const info = beneficiaries.map(b => {
      let gender = b.gender;
      if (genders) {
        const found = genders.find(g => g.id === Number(b.gender));
        if (found) {
          gender = found.value;
        }
      }
      let birthday = null;
      let createdAt = null;
      let age = 0;
      if (b.birth_date) {
        birthday = new Date(b.birth_date);
        age = now.getFullYear() - birthday.getFullYear();
        const month = now.getMonth() - birthday.getMonth();
        if (month < 0 || (month === 0 && now.getDate() < birthday.getDate())) {
          age--;
        }
        birthday = birthday.toLocaleDateString();
      }
      if (b.created_at) {
        createdAt = new Date(b.created_at);
        createdAt = createdAt.toLocaleDateString();
      }
      return {
        COMUNA: b.municipality_id,
        BARRIO: b.neighborhood?.name,
        'NOMBRE COMPLETO': b.full_name,
        'TIPO DE IDENTIFICACION': b.document_type,
        'NRO IDENTIFICACION': b.document,
        EDAD: age,
        TALLA: b?.shirtInfo?.value,
        'FECHA DE NACIMIENTO': birthday,
        SEXO: gender,
        'ESTADO CIVIL': b?.marital_status_value,
        DIRECCION: b.address,
        TELEFONO: b.cellphone,
        'CORREO ELECTRONICO': b.email,
        OCUPACION: b?.occupation_value,
        'NOMBRE DEL ACUDIENTE': b.parent,
        'TELEFONO DEL ACUDIENTE': b.parent_phone,
        'CORREO ELECTRONICO DEL ACUDIENTE': b.parent_phone,
        'PRESENTA DISCAPACIDAD': b.disability === '95' ? 'NO' : 'SI',
        'TIPO DE DISCAPACIDAD': b.disability_value,
        'HA SIDO CAMPESINO': b.farmer ? 'SI' : 'NO',
        'ENFERMEDAD CRONICA': b.chronic_disability_value?.toUpperCase(),
        'CUAL ENFERMEDAD': b.disease_name,
        'TIPO DE TRATAMIENTO': b.disease_treatment,
        'IDENTIDAD DE GENERO': b.gender_identity_value,
        'ORIENTACION SEXUAL': b?.sexual_orientation_value,
        'SITUACION DE CALLE': b.homeless ? 'SI' : 'NO',
        DESPLAZADO: b.displacement_place ? 'SI' : 'NO',
        'TIEMPO DESPLAZADO': b.displacement_time,
        'LUGAR DESPLAZAMIENTO': b.displacement_place,
        'ALGUN HECHO VICTIMIZANTE': b.victim_population_value,
        'FACTORES DE RIESGO / PROBLEMAS': b?.risk_factor_value,
        ETNIA: b.ethnic_group_value?.toUpperCase(),
        ORGANIZACION: b?.organization_value,
        'NIVEL DE ESCOLARIDAD': b.scholarship_value,
        ESCUELA: b.school?.code,
        ID_GRUPO: b.group?.id,
        GRUPO: b.group?.code,
        TIPO_RECURSO: b.school?.resource_type_id,
        TIPO_ESCUELA: b.school?.type,
        COMUNA_ESCUELA: b.school?.municipality?.name,
        FECHA_REGISTRO: createdAt
      };
    });
    setBeneficiariesInfo(info);
  }

  function handleCreateXLS() {
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(beneficiariesInfo);

    // Set column widths
    const columnWidths = [
      { wch: 15 }, // Set width of first column to 100 pixels
      { wch: 20 }, // Set width of second column to 150 pixels
      { wch: 20 }, // Set width of third column to 120 pixels
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 15 },
      { wch: 20 },
      { wch: 30 },
      { wch: 20 },
      { wch: 30 },
      { wch: 20 },
      { wch: 30 },
      { wch: 20 },
      { wch: 30 },
      { wch: 20 },
      { wch: 25 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 25 },
      { wch: 25 },
      { wch: 30 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 25 },
      { wch: 35 },
      { wch: 25 },
      { wch: 25 },
      { wch: 30 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 }
    ];
    ws['!cols'] = columnWidths;

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate a Blob from the workbook
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });

    // Create a download link and click it programmatically to download the file
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'caracterizaciones.xlsx';
    link.click();
    URL.revokeObjectURL(url);
  }

  useEffect(() => {
    generateInfo();
  }, [beneficiaries, genders]);

  return (
    <div className={'download-container'}>
      <button onClick={handleCreateXLS} title={'Descargar Beneficiarios'}>
        <img src={xls} alt='download' />
      </button>
    </div>
  );
}

export default DownloadBeneficiaries;
